import React from "react";
import AddForm from "../Components/AddLiterature/AddForm";
import Header from "../Components/Utilities/Header";
function AddLiterature() {
  return (
    <>
      <div id="addLiterature">
        <Header />
        <AddForm />
      </div>
    </>
  );
}

export default AddLiterature;
